import React from 'react'
import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

function ProtectedRoute({ children, roles }) {
  const { userInfo } = useSelector((state) => state.auth)

  if (!userInfo) {
    return <Navigate to="/signin" replace />
  }

  if (roles && !roles.includes(userInfo.role)) {
    return <Navigate to="/" replace />
  }

  return children
}

export default ProtectedRoute
